import { useCallback } from 'react';
import { useSetDeviceContext } from '../../../../components/app/InterfaceAppRunnerSideEffects/hooks/helperHooks/useSetDeviceContext';
import type { ActionHandlerType } from '../../../../context/ActionsProvider/context';
import {
  GeoLocationStatus,
  useGlobalAppStateStore,
} from '../../../../stores/app/GlobalAppStateStore';
import getGeoLocation from '../../../useUserContext/useGeoLocationContext/getGeoLocation';
import { SHOULD_PROPAGATE_UP } from '../../const';

export default function useUpdateGeolocation() {
  const interfaceRecordMetadata = useGlobalAppStateStore().hooks.record.useMetadata();
  const { setDeviceContext } = useSetDeviceContext();

  const isGeoLocationTrackingEnabled = Boolean(interfaceRecordMetadata.advanced?.location?.enable);

  const updateGeolocation: ActionHandlerType = useCallback(
    async (_args) => {
      if (!isGeoLocationTrackingEnabled) {
        throw new Error('Location tracking is not enabled');
      }

      try {
        const geoLocation = await getGeoLocation();

        if (!geoLocation) {
          throw new Error('Geo location data is null');
        }

        setDeviceContext({ location: geoLocation });
        if (geoLocation.status !== GeoLocationStatus.Granted) {
          throw new Error('Location permission is not granted');
        }
      } catch (error) {
        console.error(error);
        throw error;
      }
      return Promise.resolve(SHOULD_PROPAGATE_UP);
    },
    [isGeoLocationTrackingEnabled, setDeviceContext],
  );

  return {
    updateGeolocation,
  };
}
